"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowCardBody = void 0;
var react_1 = __importDefault(require("react"));
var CardContent_1 = __importDefault(require("@mui/material/CardContent"));
/**
 * Component that renders the body content for the workflow card.
 *
 * @param children content to render in the WorkflowCardBody
 *
 * @category Component
 */
var WorkflowCardBody = function (props) {
    var children = props.children, sx = props.sx, otherCardContentProps = __rest(props, ["children", "sx"]);
    return (react_1.default.createElement(CardContent_1.default, __assign({ sx: __spreadArray([
            __assign({ display: 'flex', flex: '1 1 0', overflow: 'auto', flexDirection: 'column', pt: 0, pb: { sm: 2, md: 3 }, px: { xs: 2, md: 3 } }, sx)
        ], (Array.isArray(sx) ? sx : [sx]), true) }, otherCardContentProps), children));
};
exports.WorkflowCardBody = WorkflowCardBody;
